import type { ReactNode } from 'react';
import { cn } from '@/lib/utils';

/**
 * A dashed container and one plain sentence.
 *
 * No illustration, no icon, no call to action unless there genuinely is a next step —
 * a centred illustration of an empty box tells an operator nothing they did not already
 * know from the empty table, and a CTA for an action they cannot perform is worse.
 */
export type EmptyStateProps = {
  title: string;
  description?: string;
  /** Only pass this when there is a real next step. */
  action?: ReactNode;
  size?: 'sm' | 'md' | 'lg';
  className?: string;
};

const PADDING = { sm: 'py-6', md: 'py-10', lg: 'py-14' } as const;

export const EmptyState = ({ title, description, action, size = 'md', className }: EmptyStateProps) => (
  <div className={cn('rounded-lg border border-dashed border-border px-6 text-center', PADDING[size], className)}>
    <p className="text-sm text-muted-foreground">{title}</p>
    {description && <p className="mx-auto mt-1 max-w-md text-sm text-subtle">{description}</p>}
    {action && <div className="mt-4 flex justify-center">{action}</div>}
  </div>
);
